import * as React from 'react';
import { FunctionComponent } from 'react';

import { Switch, Flex } from 'basecamp';

type Props = {
	value: boolean;
	id: number;
	onClick: (id: number) => void;
	dataTest?: string;
};

const SwitchRenderer: FunctionComponent<Props> = ({ value, id, onClick, dataTest }) => {
	return (
		<Flex setAs="row" withAlign="center" height="100%">
			<Switch
				isOn={value}
				setAs="primary"
				withSize="small"
				onClick={() => onClick(id)}
				dataTest={dataTest}
			/>
		</Flex>
	);
};

export default SwitchRenderer;
